/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PostContactUsForm Input Action
 */

import { IPostContactUsFormInput } from './../modules/szf-contact-us/szf-contact-us.view';
export class PostContactUsFormInput implements Msdyn365.IActionInput {
    public Inquiry:string;
    public description: string;
    public email: string;
    public firstName: string;
    public lastName: string;
    public phone: string;
    // public termNcondition: boolean;
    public updateNpromotion: boolean;
    public fileBase64Code: string | ArrayBuffer | null | undefined;
    public file: File | undefined | null;
    public token: string | undefined;
    public contactID: string | undefined;
    constructor(
        data:IPostContactUsFormInput,
        file: File | undefined | null,
        fileBase64Code: string | ArrayBuffer | null | undefined,
        CRMtoken: string | undefined,
        contactID: string | undefined
    ) {
        this.Inquiry = data.Inquiry;
        this.description = data.description;
        this.email = data.email;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.phone = `+${data.countryCode}${data.phone}`;
        // this.termNcondition = data.termNcondition;
        this.updateNpromotion = data.updateNpromotion;
        this.file = file;
        this.fileBase64Code = fileBase64Code;
        this.token = CRMtoken;
        this.contactID = contactID;
    }
    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CONTACTUSFORM`;
    public getCacheObjectType = () => 'CONTACTUSFORM';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IPostContactUsFormData {
    status: boolean;
    msg:string | undefined;
    id: string | undefined;
}


/**
 * TODO: Use this function to create the input required to make the action call
 */
const contactFormInput = (args: Msdyn365.ICreateActionContext,inputData:IPostContactUsFormInput,file: File | undefined | null,fileBase64Code: string | ArrayBuffer | null | undefined , CRMtoken: string | undefined, contactID:string|undefined ): Msdyn365.IActionInput => {
    return new PostContactUsFormInput(inputData,file,fileBase64Code,CRMtoken,contactID);
};


/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function contactFormDataAction(input: PostContactUsFormInput, ctx: Msdyn365.IActionContext): Promise<IPostContactUsFormData> {
    try{
        const token = input.token;
        const szfCRMDomain = ctx.requestContext.app.config.szfCRMDomain;
        let data = {};
        if(input.file && input.file.name){
            data = {
                "title" : `Case by {${input.firstName} ${input.lastName}_${input.email}}`,
                "customerid_contact@odata.bind": `/contacts(${input.contactID})`, //Contact, to be replaced by contact created
                "szf_CaseType@odata.bind": `/szf_casetypes(${input.Inquiry})`, //Get case type first, then replace it with the ID
                "caseorigincode":3, //Website, will remain hardcoded
                "prioritycode": 2, //Normal, will remain hardcoded
                "szf_description":`${input.description}`, // Details of case
                "Incident_Annotation":[{ //File
                    "filename" :`${input.file?.name}`,
                    "isdocument" : true,
                    "subject":`${input.file?.name}`,
                    "documentbody" : `${input.fileBase64Code}`
                }]
            };
        }else{
            data = {
                "title" : `Case by {${input.firstName} ${input.lastName}_${input.email}}`,
                "customerid_contact@odata.bind": `/contacts(${input.contactID})`, //Contact, to be replaced by contact created
                "szf_CaseType@odata.bind": `/szf_casetypes(${input.Inquiry})`, //Get case type first, then replace it with the ID
                "caseorigincode":3, //Website, will remain hardcoded
                "prioritycode": 2, //Normal, will remain hardcoded
                "szf_description":`${input.description}`, // Details of case
            };
        }
        
        const response = await Msdyn365.sendRequest<any>(`${szfCRMDomain}/api/data/v9.2//incidents`, "post", data, {
            timeout: 15000,
            headers: {
                'Prefer': 'return=representation',
                'Authorization':`Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        if(response && response.data && response.data.incidentid){
            return {
                status: true,
                msg: 'success',
                id: response.data.incidentid
            };
        }else if (response && response.data && response.data.error){
            return {
                status: false,
                msg: response.data.error.message,
                id: undefined
            };
        }else{
            return {
                status: false,
                msg: undefined,
                id: undefined
            };
        }
    }catch(error){
        return {
            status: false,
            id: undefined,
            msg: 'Something went wrong, Please try again later.'
        };
    }
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<any>>contactFormDataAction,
    // TODO: Give your data action a unique id
    id: 'PostContactUsForm',
    input: contactFormInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
